import { USER_ROLES } from "../../constants";
import {
  FETCH_REFILL_LIST,
  RESET_REFILL_LIST,
} from "../../constants/action.constants";

const initialState = {
  payload: { limit: 10, total: 0, offset: 0 },
  list: [],
  selectList: [],
  others: {},
};

const refillListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFILL_LIST:
      let temp = action.payload.data.filter(
        (role) => role.role_code !== USER_ROLES.COMPANY_ADMIN
      );
      return {
        list: action.payload.data,
        payload: action.payload.payload,
        selectList: temp,
        others: action.others,
      };
    case RESET_REFILL_LIST:
      return initialState;
    default:
      return state;
  }
};

export default refillListReducer;
